import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{contactData.title}</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-foreground-600 text-sm md:text-base mb-8">{contactData.description}</p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-qq-line text-secondary-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">QQ群</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.qq}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}